import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEquatorialGuinea = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_29_426)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.30434 7.82611H23.2535C21.5581 3.2565 17.1595 0 12 0C8.68621 0 5.68654 1.34339 3.51511 3.51511L7.30434 7.82611Z",
				fill: "#6DA544"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.30434 16.1739H23.2535C21.5581 20.7435 17.1595 24 12 24C8.68621 24 5.68654 22.6566 3.51511 20.4849L7.30434 16.1739Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3.51468 3.51469C-1.1716 8.20097 -1.1716 15.799 3.51468 20.4853C5.45122 18.5488 7.31371 16.6863 12 12L3.51468 3.51469Z",
				fill: "#0052B4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M14.087 9.91303V12.5217C14.087 14.1192 16.1739 14.6087 16.1739 14.6087C16.1739 14.6087 18.2609 14.1192 18.2609 12.5217V9.91303H14.087Z",
				fill: "#DEDDE0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M15.6522 12.0522H16.6957V13.5652H15.6522V12.0522Z",
				fill: "#786145"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M17.2174 11.4783C17.2174 10.902 16.7502 10.4348 16.1739 10.4348C15.5976 10.4348 15.1304 10.902 15.1304 11.4783C14.8423 11.4783 14.6087 11.7119 14.6087 12C14.6087 12.2881 14.8423 12.5217 15.1304 12.5217H17.2174C17.5055 12.5217 17.7391 12.2881 17.7391 12C17.7391 11.7119 17.5056 11.4783 17.2174 11.4783Z",
				fill: "#6DA544"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_29_426",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgEquatorialGuinea;
